import { Typography } from "@circle-react-uikit/Typography";

import { usePlanStatus } from "@/react/hooks/usePlanStatus";

interface LegacyEnterpriseBannerProps {
  message: string;
}

export const LegacyEnterpriseBanner = ({
  message,
}: LegacyEnterpriseBannerProps) => {
  const { isLegacyEnterprisePlan } = usePlanStatus();

  if (!isLegacyEnterprisePlan) {
    return null;
  }

  return (
    <div
      className="mt-4 rounded-xl border border-amber-200 bg-amber-100 p-6 dark:border-primary dark:bg-primary"
      data-testid="legacy-enterprise-banner"
    >
      <Typography.BodyMd color="text-default">{message}</Typography.BodyMd>
    </div>
  );
};
